import React from 'react';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import Icon from '../../../components/AppIcon';

const UsageTrendsChart = ({ data }) => {
  const formatCurrency = (value) => {
    return new Intl.NumberFormat('en-PG', {
      style: 'currency',
      currency: 'PGK',
      minimumFractionDigits: 0
    })?.format(value || 0);
  };

  const formatDate = (dateString) => {
    if (!dateString) return '';
    const date = new Date(dateString);
    return date?.toLocaleDateString('en-US', { month: 'short', year: 'numeric' });
  };

  const chartData = data?.map(item => ({
    period: formatDate(item?.pay_period_start),
    payroll: parseFloat(item?.total_gross || 0),
    status: item?.payroll_status
  })) || [];

  return (
    <div className="bg-white rounded-lg shadow-sm p-6">
      <div className="flex items-center justify-between mb-6">
        <div>
          <h2 className="text-xl font-semibold text-gray-900">Monthly Usage Trends</h2>
          <p className="text-sm text-gray-600 mt-1">Payroll processing volume over time</p>
        </div>
        <div className="flex items-center gap-2 text-sm text-gray-600">
          <Icon name="TrendingUp" className="w-4 h-4" />
          <span>Last 12 months</span>
        </div>
      </div>
      {chartData?.length > 0 ? (
        <ResponsiveContainer width="100%" height={300}>
          <LineChart data={chartData}>
            <CartesianGrid strokeDasharray="3 3" stroke="#e5e7eb" />
            <XAxis
              dataKey="period"
              stroke="#6b7280"
              style={{ fontSize: '12px' }}
            />
            <YAxis
              stroke="#6b7280"
              style={{ fontSize: '12px' }}
              tickFormatter={formatCurrency}
            />
            <Tooltip
              formatter={(value) => formatCurrency(value)}
              contentStyle={{
                backgroundColor: '#fff',
                border: '1px solid #e5e7eb',
                borderRadius: '8px',
                padding: '12px'
              }}
            />
            <Legend />
            <Line
              type="monotone"
              dataKey="payroll"
              stroke="#3b82f6"
              strokeWidth={2}
              dot={{ fill: '#3b82f6', r: 4 }}
              activeDot={{ r: 6 }}
              name="Payroll Processed"
            />
          </LineChart>
        </ResponsiveContainer>
      ) : (
        <div className="flex items-center justify-center h-64 text-gray-500">
          <div className="text-center">
            <Icon name="BarChart3" className="w-12 h-12 mx-auto mb-2 text-gray-400" />
            <p>No usage data available</p>
          </div>
        </div>
      )}
    </div>
  );
};

export default UsageTrendsChart;